module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/conlallave.e433b9b7.svg";